/**
 * ErrorStates — a set of small exported components rather than one
 * screen, since these get mounted independently across the app.
 *
 *   <NotFound onBack={...} />
 *   <ServerError onRetry={...} />
 *   <UnreachableFeedBanner feedId="suite-3" hoursDown={26} />
 *   <MassDeletionBanner feedId="villa-42" />   — R2 debounce-mass-deletion warning
 */

export function NotFound({ onBack }) {
  return (
    <div style={{ textAlign: "center", padding: "28px 16px", border: "1px solid var(--border)", borderRadius: "var(--radius)" }}>
      <p style={{ fontSize: "var(--text-md)", fontWeight: 500, margin: "10px 0 4px" }}>404 — Not found</p>
      <p style={{ fontSize: "var(--text-xs)", color: "var(--text-secondary)", margin: "0 0 12px" }}>
        This project or feed doesn't exist, or you don't have access.
      </p>
      <button className="ical-btn" style={{ padding: "6px 14px", fontSize: "var(--text-xs)" }} onClick={onBack}>
        Back to dashboard
      </button>
    </div>
  );
}

export function ServerError({ onRetry }) {
  return (
    <div style={{ textAlign: "center", padding: "28px 16px", border: "1px solid var(--border)", borderRadius: "var(--radius)" }}>
      <p style={{ fontSize: "var(--text-md)", fontWeight: 500, margin: "10px 0 4px" }}>500 — Something broke</p>
      <p style={{ fontSize: "var(--text-xs)", color: "var(--text-secondary)", margin: "0 0 12px" }}>
        We've been notified. Try again in a moment.
      </p>
      <button className="ical-btn" style={{ padding: "6px 14px", fontSize: "var(--text-xs)" }} onClick={onRetry}>
        Retry
      </button>
    </div>
  );
}

// R1: a non-200 response is not data — feed gets paused, not diffed as deleted.
export function UnreachableFeedBanner({ feedId, hoursDown }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--bg-danger)", color: "var(--text-danger)", borderRadius: "var(--radius)", padding: "10px 14px" }}>
      <span>⚠</span>
      <span style={{ fontSize: "var(--text-sm)" }}>
        Feed <strong>{feedId}</strong> has been unreachable for {hoursDown} hours. Polling paused after repeated non-200 responses.
      </span>
    </div>
  );
}

// R2: debounce mass deletions — re-confirm before notifying subscribers.
export function MassDeletionBanner({ feedId }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--bg-warning)", color: "var(--text-warning)", borderRadius: "var(--radius)", padding: "10px 14px" }}>
      <span>⚠</span>
      <span style={{ fontSize: "var(--text-sm)" }}>
        A large drop in events was detected on <strong>{feedId}</strong> — re-checking before notifying subscribers.
      </span>
    </div>
  );
}
